import { storeToRefs } from 'pinia'
import { useSelectedVisualizationColumnStore } from '@/stores/selectedVisualizationColumnStore'
import { computed, onMounted } from 'vue'
import type { SelectedVisualizationColumn } from '@/stores/type/selectedVisualizationColumn'
import { useProjectStore } from '@/stores/project'
import { useBoreholeSampleObservationStore } from '@/stores/boreholeSampleObservation'

export function useSelectableColumns(updateDatabaseDelay = 300) {
  const selectedVisualizationColumnStore = useSelectedVisualizationColumnStore()
  const boreholeSampleObservationStore = useBoreholeSampleObservationStore()
  const projectStore = useProjectStore()
  const currentProjectUserId = projectStore?.currentItem?.current_project_user?.id
  const {
    items: selectedColumns,
    writeLoading,
    rawSelectedColumns
  } = storeToRefs(selectedVisualizationColumnStore)
  const debounceFn = useDebounceFn((columns: SelectedVisualizationColumn[]) => {
    selectedVisualizationColumnStore.bulkCreate(columns)
  }, updateDatabaseDelay)
  const selectedColumnsDisplay = computed({
    get() {
      return rawSelectedColumns.value
    },
    set(columnNames: string[]) {
      rawSelectedColumns.value = columnNames
      debounceFn(
        columnNames.map((name) => ({
          name,
          project_user: currentProjectUserId
        }))
      )
    }
  })

  onMounted(() => {
    const selectableColumns = boreholeSampleObservationStore.selectableColumns
    rawSelectedColumns.value = selectedColumns.value.reduce((result, column) => {
      const columnName = column.name
      if (selectableColumns.includes(columnName)) {
        result.push(columnName)
      }
      return result
    }, [])
  })

  return {
    selectedColumnsDisplay,
    writeLoading
  }
}
